// Pure helper deciding which camera CameraDetail renders as primary. A ?camera=
// id that names a device absent from `cameras` (the role's authorized list)
// resolves to not-found rather than falling back to a different camera — that's
// the requestedMissing flag.

export interface ResolvableCamera {
  doorbot_id: string;
  status: string;
}

export interface ResolvedPrimaryCamera<T> {
  /** The camera to render, or null when none resolves. */
  camera: T | null;
  /** True only when ?camera= was specified but is absent from `cameras`. */
  requestedMissing: boolean;
}

export function resolvePrimaryCamera<T extends ResolvableCamera>(
  cameras: T[],
  selectedCameraId: string | null,
): ResolvedPrimaryCamera<T> {
  if (cameras.length === 0) {
    return { camera: null, requestedMissing: false };
  }
  if (selectedCameraId) {
    const found = cameras.find((c) => c.doorbot_id === selectedCameraId);
    if (found) return { camera: found, requestedMissing: false };
    return { camera: null, requestedMissing: true };
  }
  const online = cameras.find((c) => c.status === "online");
  return { camera: online ?? cameras[0] ?? null, requestedMissing: false };
}
